// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"126":"styles/editor","692":"styles/app"}[chunkId] + ".css";
};